import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { ParcelCrudService } from 'src/app/shared/services/parcel-crud.service';
import { Parcel } from 'src/app/shared/interfaces/parcel';

@Component({
  selector: 'app-parcels',
  templateUrl: './parcels.component.html',
  styleUrls: ['./parcels.component.scss']
})
export class ParcelsComponent implements OnInit {

  parcels: Parcel[];
  parcel: Parcel;
  selectedParcels: Parcel[] = [];

  parcelDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private parcelService : ParcelCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Parcels'}
    ];

    this.parcels = [];
    this.parcel = { } as Parcel ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.parcelService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.parcels = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Parcel = jsonItem as Parcel;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.parcels.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.parcelService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.parcels);
            doc.save('parcels.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.parcels);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "parcels");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedParcels);
      // console.log('SAVEC CSV LOCATIONS ', this.parcels);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedParcels, 'parcels', exportCols);
   // this.exportService.exportToCsv(this.parcels, 'parcels', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.parcel = {} as Parcel;
    this.submitted = false;
    this.parcelDialog = true;
  }

  deleteSelectedParcels() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected parcels?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.parcels = this.parcels.filter(val => !this.selectedParcels.includes(val));
            
            this.selectedParcels.forEach( parcel => this.parcelService.delete(parcel.$key));
            this.selectedParcels = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Parcelss Deleted', life: 3000});
        }
    });
  }

  editParcel(parcel: Parcel) {
    this.parcel = {...parcel};
    this.parcelDialog = true;
  }

  deleteParcel(parcel: Parcel) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + parcel.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.parcels = this.parcels.filter(val => val.$key !== parcel.$key);
            this.parcel = {} as Parcel;
            this.parcelService.delete(parcel.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Parcel Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.parcelDialog = false;
    this.submitted = false;
  }

  saveParcel() {
    this.submitted = true;

    if ( this.parcel.name.trim() ) {
      this.parcel.isEnabled = true;
      
      if (this.parcel.$key) {
          this.parcels[this.findIndexById(this.parcel.$key)] = this.parcel;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Parcel Updated', life: 3000});
          this.parcelService.update(this.parcel);
        } else {
          this.parcel.position = this.parcels.length;
          this.parcelService.add(this.parcel);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Parcel Created', life: 3000});
      this.parcels = [...this.parcels];
    }

    this.parcelDialog = false;
    this.parcel = { } as Parcel;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.parcels.length; i++) {
        if (this.parcels[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeParcel(parcel : Parcel) {
    //console.log("SAVE", parcel);
    this.parcelService.update(parcel);
  }

  completePosition(parcel : Parcel) {
   // console.log("SAVE", parcel);
  //  this.parcelService.updateParcel(parcel);


    if ( this.newPosition > -1 ) {
        parcel.position = this.newPosition;
        parcel = this.checkPositionLimits(parcel);
        this.reorderElements(parcel);
        //this.updateDB(parcel);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.parcels);
    // const myClonedArray = [];
    // this.parcels.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.parcels.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.parcels.length - 1 - event.dropIndex;
    const parcelToMove = this.parcels[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.parcels[index] = this.parcels[index+1];
        this.parcels[index].position = index;
        this.parcelService.update(this.parcels[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.parcels[index] = this.parcels[index-1];
        this.parcels[index].position = index;
        this.parcelService.update(this.parcels[index]);
      }
    } 
    this.parcels[endIndex] = parcelToMove;
    this.parcels[endIndex].position = endIndex;
    this.parcelService.update(this.parcels[endIndex]);
  }

  // onFieldEdit(parcel: Spray, fieldName: string): void {
  //   //console.log(this.parcels);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + parcel[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       parcel.position = this.newPosition;
  //       parcel = this.checkPositionLimits(parcel);
  //       this.reorderElements(parcel);
  //       //this.updateDB(parcel);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(parcel);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.parcels.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, parcel: Parcel) {
    // console.log("event" +event);
    if (parcel.position != null && parcel.position > -1) {
      this.previousPosition = parcel.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(parcel: Parcel) {
    console.log('check ',parcel.position + ' ' + this.parcels.length);
    if (!parcel.position) {
     // console.log('check 1');
      return this.parcel;
    }
    if (parcel.position < 0) {
      parcel.position = 0;
      // console.log('check 2');
      return parcel;
    }
    if (parcel.position > this.parcels.length) {
      parcel.position = this.parcels.length - 1;
    //  console.log('check 3', parcel.position);
      return parcel;
    }
   // console.log('check 4');
    return parcel;
  }

  async reorderElements(parcel: Parcel) {
    this.newPosition = this.newPosition  > this.parcels.length ? this.parcels.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === parcel.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const parcelToMove = this.parcels[startIndex];
   // console.log('Item to move: ', this.parcels[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.parcels);
        console.log('Item to +1: ', this.parcels[index+1]);

        this.parcels[index] = this.parcels[index+1];
        this.parcels[index].position = index;
        // console.log('Move: ', this.parcels[index+1]);
        // console.log('Move pos: ', this.parcels[index].position);
        //await this.updateDB(this.parcels[index]);
        this.parcelService.update(this.parcels[index]);
     //   console.log('Update DB: ', this.parcels[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.parcels[index] = this.parcels[index-1];
        this.parcels[index].position = index;
        this.parcelService.update(this.parcels[index]);
      }
    } 
    this.parcels[endIndex] = parcelToMove;
    this.parcels[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.parcelService.update(this.parcels[endIndex]);
    
    // const myClonedArray = [];
    // this.parcels.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.parcels = myClonedArray;
   // this.getAllRecords();
  }
}
